import {
  Autocomplete,
  InputAdornment,
  SvgIcon,
  TextField,
} from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  useRecoilCallback,
  useRecoilState,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import InputLabelCustom from "../../../shared/components/forms/InputLabelCustom";
import AutocompleteSkeleton from "../../../shared/components/skeletons/AutocompleteSkeleton";
import { capitalizeWords, finderProfessionalByName } from "../../../shared/global/helpers";
import {
  daysAvailableState,
  filterSearchSelectedState,
  hoursAvailableState,
  isChangeFormSearchState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
} from "../../state/atoms";
import { dayDefaultAvailableState } from "../calendars/state/atoms";
import {
  professionalsBySpecialityState,
  professionalsByServiceState,
  professionalsState,
  specialitiesByServiceState,
} from "./state/atoms";
import { PlaceOutlined } from "@mui/icons-material";
import EspecialistaIcon from "../../../shared/icons/EspecialistaIcon";

const AutocompleteProfessionals = ({ size = "small", styles }) => {
  const { catchErrorApi } = useCatchErrorApi();
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );
  const [professionals, setProfessionals] = useRecoilState(professionalsState);
  const [loading, setLoading] = useState(false);
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState
  );
  const resetDaysAvailable = useResetRecoilState(daysAvailableState);
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);
  const resetProfessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState
  );
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState
  );

  const lugar = window.location.pathname.indexOf("buscar") >= 0;

  const loadProfessionals = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        setLoading(true);
        try {
          let sucursalCode = filterSearchSelected.sucursalSelected.code;
          let especialidadCode = filterSearchSelected.specialitySelected.code;
          let clinicaValue = filterSearchSelected.clinicaSelected.value;
          console.log("code5", sucursalCode, especialidadCode, clinicaValue);
          
          
          // console.log("SUCURSAL CODE3 => ", sucursalCode );
          // console.log("ESPECIALIDAD CODE3 => ", especialidadCode );

          if (especialidadCode != null) {
            let obj = {
              codSpeciality: especialidadCode,
              sucursalCode: sucursalCode,
            };
            const professionalsFetch = await snapshot.getPromise(
              professionalsByServiceState(obj)
            );            
            console.log(professionalsFetch, "code5 1");
            
            setProfessionals(professionalsFetch);
          } else if(clinicaValue != "" && sucursalCode === null) {
            const professionalsFetch = await snapshot.getPromise(professionalsBySpecialityState(filterSearchSelected.specialitySelected.value));
            console.log(professionalsFetch, "code5 2");
            setProfessionals(professionalsFetch)
          }else if (sucursalCode != null) {
            let obj = {
              codSpeciality: "0",
              sucursalCode: sucursalCode,
            };
            const professionalsFetch = await snapshot.getPromise(
              professionalsByServiceState(obj)
            );            
            console.log(professionalsFetch, "code5 110");

            setProfessionals(professionalsFetch);
          }
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoading(false);
        }
      },
    [filterSearchSelected.specialitySelected.value]
  );

  useEffect(() => {
    loadProfessionals();

    // return () => {
    //   loadProfessionals();
    // };
  }, [loadProfessionals]);

  if (loading) return <AutocompleteSkeleton />;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-profesional"
        text="Nombre del especialista (Opcional)"
        style={{ ...styles.label }}
      />
      <Autocomplete
        sx={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-profesional"
        options={
          professionals ? professionals.map((option) => `${option.ptdNombre}`) : []
        }
        getOptionLabel={(option) => capitalizeWords(option) || null}
        value={filterSearchSelected.professionalSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          resetDayDefaultAvailable();
          resetDaysAvailable();
          resetHoursAvailable();
          resetProfessionalsMatchCovenant();
          resetProfessionalsNoMatchCovenant();

          if (reason === "clear") {
            setFilterSearchSelected({
              ...filterSearchSelected,
              professionalSelected: {
                ...filterSearchSelected.professionalSelected,
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            const finderProfessional = finderProfessionalByName(
              professionals,
              value
            );
            setFilterSearchSelected({
              ...filterSearchSelected,
              professionalSelected: {
                ...filterSearchSelected.professionalSelected,
                value: value,
                code: finderProfessional?.ptdRut,
              },
            });
            loadProfessionals()
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              input: {
                "&::placeholder": {
                  ...styles.autocomplete,
                  opacity: 1,
                  fontWeight: 400,
                },
              },
            }}
            placeholder="Nombre del especialista (Opcional)"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                (lugar > 0 ) ?                 
                <>
                <SvgIcon sx={{fontSize: "15px"}}>
                  <EspecialistaIcon />
                </SvgIcon>
                  {params.InputProps.startAdornment}
                </>: null

              ),                  
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompleteProfessionals;
